"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSchedule = createSchedule;
exports.endpoints = void 0;
exports.executeBreak = executeBreak;
exports.fetchBreakSettings = fetchBreakSettings;
exports.fetchRecentMessages = fetchRecentMessages;
exports.fetchStatus = fetchStatus;
exports.removeRecentMessage = removeRecentMessage;
exports.removeSchedule = removeSchedule;
exports.updateBreakSetting = updateBreakSetting;
exports.updateSchedule = updateSchedule;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _get = _interopRequireDefault(require("lodash/get"));
var _requests = require("@edison/requests");
var _functools = require("@edison/functools");
var _utils = require("./utils");
var _constants = require("../utils/constants");
var _excluded = ["schedules"],
  _excluded2 = ["schedules"],
  _excluded3 = ["id"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var endpoints = exports.endpoints = {
  status: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/inbox_break/status");
    }
  },
  list: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/inbox_break/setting");
    }
  },
  update: {
    method: 'PATCH',
    url: function url() {
      return "/".concat(_constants.API_V1, "/inbox_break/setting");
    }
  },
  createSchedule: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/inbox_break/schedule");
    }
  },
  updateSchedule: {
    method: 'PUT',
    url: function url(id) {
      return "/".concat(_constants.API_V1, "/inbox_break/schedule/").concat(id);
    }
  },
  removeSchedule: {
    method: 'DELETE',
    url: function url(id) {
      return "/".concat(_constants.API_V1, "/inbox_break/schedule/").concat(id);
    }
  },
  listMessages: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/inbox_break/message");
    }
  },
  removeMessage: {
    method: 'DELETE',
    url: function url(id) {
      return "/".concat(_constants.API_V1, "/inbox_break/message/").concat(id);
    }
  },
  execute: {
    method: 'PUT',
    url: function url() {
      return "/".concat(_constants.API_V1, "/inbox_break/execute");
    }
  }
};
/**
 * Returns the status for current break and next round
 *
 * @public
 * @param {Auth} auth
 * @return {Promise<BreakStatusResponse>}
 */
function fetchStatus(_x) {
  return _fetchStatus.apply(this, arguments);
}
function _fetchStatus() {
  _fetchStatus = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var auth, optionals, _endpoints$status, method, url, res;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          auth = _ref.auth;
          optionals = (0, _utils.withAuth)(auth)(_utils.defaultOptionals);
          _endpoints$status = endpoints.status, method = _endpoints$status.method, url = _endpoints$status.url;
          _context.next = 5;
          return (0, _requests.request)(url(), method, optionals);
        case 5:
          res = _context.sent;
          return _context.abrupt("return", res);
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchStatus.apply(this, arguments);
}
/**
 * Returns the current break status and the list of scheduled breaks
 *
 * @public
 * @param {Auth} auth
 * @return {Promise<BreakSettingsResponse>}
 */
function fetchBreakSettings(_x2) {
  return _fetchBreakSettings.apply(this, arguments);
}
function _fetchBreakSettings() {
  _fetchBreakSettings = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref2) {
    var auth, optionals, _endpoints$list, method, url, res, _res$result, schedules, restData;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          auth = _ref2.auth;
          optionals = (0, _utils.withAuth)(auth)(_utils.defaultOptionals);
          _endpoints$list = endpoints.list, method = _endpoints$list.method, url = _endpoints$list.url;
          _context2.next = 5;
          return (0, _requests.request)(url(), method, optionals);
        case 5:
          res = _context2.sent;
          _res$result = res.result, schedules = _res$result.schedules, restData = (0, _objectWithoutProperties2["default"])(_res$result, _excluded);
          return _context2.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
            result: _objectSpread(_objectSpread({}, restData), {}, {
              schedules: schedules.map(function (schedule) {
                return _utils.scheduledBreakTransformer.fromAPI(schedule);
              })
            })
          }));
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _fetchBreakSettings.apply(this, arguments);
}
/**
 * Update the settings for current break
 *
 * @public
 * @param {Auth} auth
 * @param {string} replyMessage
 * @param {boolean} enableAutoReply
 * @return {Promise<BreakSettingUpdateRequest>}
 */
function updateBreakSetting(_x3, _x4) {
  return _updateBreakSetting.apply(this, arguments);
}
/**
 * Create a scheduled break by given settings
 *
 * @public
 * @param {Auth} auth
 * @param {scheduledBreak} schedule
 * @return {Promise<APIResponse<string>>}
 */
function _updateBreakSetting() {
  _updateBreakSetting = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(_ref3, _ref4) {
    var replyMessage, enableAutoReply, auth, optionals, _endpoints$update, method, url, res, _res$result2, schedules, restData;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          replyMessage = _ref3.replyMessage, enableAutoReply = _ref3.enableAutoReply;
          auth = _ref4.auth;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
            replyMessage: replyMessage,
            enableAutoReply: enableAutoReply
          }))(_utils.defaultOptionals);
          _endpoints$update = endpoints.update, method = _endpoints$update.method, url = _endpoints$update.url;
          _context3.next = 6;
          return (0, _requests.request)(url(), method, optionals);
        case 6:
          res = _context3.sent;
          _res$result2 = res.result, schedules = _res$result2.schedules, restData = (0, _objectWithoutProperties2["default"])(_res$result2, _excluded2);
          return _context3.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
            result: _objectSpread(_objectSpread({}, restData), {}, {
              schedules: schedules.map(function (schedule) {
                return _utils.scheduledBreakTransformer.fromAPI(schedule);
              })
            })
          }));
        case 9:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _updateBreakSetting.apply(this, arguments);
}
function createSchedule(_x5, _x6) {
  return _createSchedule.apply(this, arguments);
}
/**
 * Update the created scheduled break
 *
 * @public
 * @param {Auth} auth
 * @param {CreatedScheduledBreak} schedule
 * @return {Promise<APIResponse<string>>}
 */
function _createSchedule() {
  _createSchedule = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(schedule, _ref5) {
    var auth, optionals, _endpoints$createSche, method, url, res;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          auth = _ref5.auth;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)(_utils.scheduledBreakTransformer.toAPI(schedule)))(_utils.defaultOptionals);
          _endpoints$createSche = endpoints.createSchedule, method = _endpoints$createSche.method, url = _endpoints$createSche.url;
          _context4.next = 5;
          return (0, _requests.request)(url(), method, optionals);
        case 5:
          res = _context4.sent;
          if (!(res.status !== 200)) {
            _context4.next = 8;
            break;
          }
          throw new _requests.RequestError((0, _get["default"])(res, 'message'), '', res.status);
        case 8:
          return _context4.abrupt("return", res);
        case 9:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _createSchedule.apply(this, arguments);
}
function updateSchedule(_x7, _x8) {
  return _updateSchedule.apply(this, arguments);
}
/**
 * Remove a scheduled break by given ID
 *
 * @public
 * @param {Auth} auth
 * @param {string} id
 * @return {Promise<APIResponse<string>>}
 */
function _updateSchedule() {
  _updateSchedule = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(schedule, _ref6) {
    var auth, id, payload, optionals, _endpoints$updateSche, method, url, res;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          auth = _ref6.auth;
          id = schedule.id, payload = (0, _objectWithoutProperties2["default"])(schedule, _excluded3);
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)(_utils.scheduledBreakTransformer.toAPI(payload)))(_utils.defaultOptionals);
          _endpoints$updateSche = endpoints.updateSchedule, method = _endpoints$updateSche.method, url = _endpoints$updateSche.url;
          _context5.next = 6;
          return (0, _requests.request)(url(id), method, optionals);
        case 6:
          res = _context5.sent;
          return _context5.abrupt("return", res);
        case 8:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _updateSchedule.apply(this, arguments);
}
function removeSchedule(_x9, _x10) {
  return _removeSchedule.apply(this, arguments);
}
function _removeSchedule() {
  _removeSchedule = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(id, _ref7) {
    var auth, optionals, _endpoints$removeSche, method, url, res;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          auth = _ref7.auth;
          optionals = (0, _utils.withAuth)(auth)(_utils.defaultOptionals);
          _endpoints$removeSche = endpoints.removeSchedule, method = _endpoints$removeSche.method, url = _endpoints$removeSche.url;
          _context6.next = 5;
          return (0, _requests.request)(url(id), method, optionals);
        case 5:
          res = _context6.sent;
          return _context6.abrupt("return", res);
        case 7:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _removeSchedule.apply(this, arguments);
}
/**
 * List the recent reply messages
 *
 * @public
 * @param {Auth} auth
 * @return {Promise<RecentMessageListResponse>}
 */
function fetchRecentMessages(_x11) {
  return _fetchRecentMessages.apply(this, arguments);
}
/**
 * Remove specified recent reply message
 *
 * @public
 * @param {Auth} auth
 * @param {string} id
 * @return {Promise<APIResponse<string>>}
 */
function _fetchRecentMessages() {
  _fetchRecentMessages = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(_ref8) {
    var auth, optionals, _endpoints$listMessag, method, url, res;
    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          auth = _ref8.auth;
          optionals = (0, _utils.withAuth)(auth)(_utils.defaultOptionals);
          _endpoints$listMessag = endpoints.listMessages, method = _endpoints$listMessag.method, url = _endpoints$listMessag.url;
          _context7.next = 5;
          return (0, _requests.request)(url(), method, optionals);
        case 5:
          res = _context7.sent;
          return _context7.abrupt("return", res);
        case 7:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _fetchRecentMessages.apply(this, arguments);
}
function removeRecentMessage(_x12, _x13) {
  return _removeRecentMessage.apply(this, arguments);
}
/**
 * Turn on/off a break manually
 *
 * @public
 * @param {Auth} auth
 * @param {boolean} enable
 * @param {boolean} enableAutoReply
 * @param {string} replyMessage
 * @return {Promise<APIResponse<void>>}
 */
function _removeRecentMessage() {
  _removeRecentMessage = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(id, _ref9) {
    var auth, optionals, _endpoints$removeMess, method, url, res;
    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          auth = _ref9.auth;
          optionals = (0, _utils.withAuth)(auth)(_utils.defaultOptionals);
          _endpoints$removeMess = endpoints.removeMessage, method = _endpoints$removeMess.method, url = _endpoints$removeMess.url;
          _context8.next = 5;
          return (0, _requests.request)(url(id), method, optionals);
        case 5:
          res = _context8.sent;
          return _context8.abrupt("return", res);
        case 7:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _removeRecentMessage.apply(this, arguments);
}
function executeBreak(_x14, _x15) {
  return _executeBreak.apply(this, arguments);
}
function _executeBreak() {
  _executeBreak = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(_ref10, _ref11) {
    var enable, enableAutoReply, replyMessage, auth, optionals, _endpoints$execute, method, url, res;
    return _regenerator["default"].wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          enable = _ref10.enable, enableAutoReply = _ref10.enableAutoReply, replyMessage = _ref10.replyMessage;
          auth = _ref11.auth;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
            enableAutoReply: enableAutoReply,
            replyMessage: replyMessage,
            action: enable ? 1 : 0
          }))(_utils.defaultOptionals);
          _endpoints$execute = endpoints.execute, method = _endpoints$execute.method, url = _endpoints$execute.url;
          _context9.next = 6;
          return (0, _requests.request)(url(), method, optionals);
        case 6:
          res = _context9.sent;
          return _context9.abrupt("return", res);
        case 8:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return _executeBreak.apply(this, arguments);
}
//# sourceMappingURL=inbox-break.js.map